import React, { useState, useEffect } from 'react'
import { Button, Stack, TextField, Typography, useTheme } from '@mui/material'
import { PromoCodeComponentProps, PromoCodeComponentState } from './types'
import { FormState } from '../types'
import { handleChange } from '../../../services/formhelper.service'

export const PromoCodeComponent: React.FC<PromoCodeComponentProps> = ({
  formData,
  setFormData,
  inValidCode,
  onSkip
}) => {
  const theme = useTheme()

  const [values, setValues] = useState<FormState<PromoCodeComponentState>>({
    ...formData,
    skipped: false
  })

  useEffect(() => {
    const promocode = values.promocode.toUpperCase()
    setFormData({ promocode })

    if (values.skipped) {
      onSkip()
    }
  }, [values])

  const handleSkip = (event: React.FormEvent) => {
    event.preventDefault()
    setFormData({ promocode: '' })
    setValues({ ...values, skipped: true, promocode: '' })
  }

  return (
    <Stack spacing={2}>
      <TextField
        id="promo-code"
        sx={{
          maxWidth: 300,
          minWidth: 250
        }}
        variant="outlined"
        value={values.promocode}
        helperText={
          inValidCode &&
          'The promo code you entered was incorrect. Please try again or click skip below'
        }
        error={inValidCode}
        FormHelperTextProps={{
          style: {
            margin: 0
          }
        }}
        inputProps={{
          style: {
            textAlign: 'center',
            fontSize: '1.4rem',
            backgroundImage: `linear-gradient(to right, ${theme.palette.gradient.main}, ${theme.palette.secondary.main})`,
            textTransform: 'uppercase'
          }
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setValues(
            handleChange<PromoCodeComponentState>('promocode', values, e)
          )
        }
      />

      <Typography component="div" variant="caption">
        Don't have a code? You can {''}
        <Button
          variant="text"
          size="small"
          sx={{
            fontSize: 'inherit',
            textTransform: 'none',
            padding: 0,
            color: theme.palette.secondary.main,
            verticalAlign: 'initial'
          }}
          onClick={handleSkip}
        >
          skip this step
        </Button>
      </Typography>
    </Stack>
  )
}
